document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.impact-slider');

  sliders.forEach(function (impactSlider) {
    if (!impactSlider) {
      return;
    }

    var sectionInner = impactSlider.closest('.sec-Section_Inner');
    var progressBar = sectionInner ? sectionInner.querySelector('.progress-bar') : null;

    var flickityOptions = {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      freeScroll: false,
      pageDots: false,
      groupCells: 1,
    };

    var flickityInstance = new Flickity(impactSlider, flickityOptions);

    flickityInstance.cells.forEach(function (cell) {
      cell.element.style.opacity = '';
    });

    function updateProgressBar(progress) {
      if (!progressBar) {
        return;
      }
      progress = Math.max(0, Math.min(1, progress));
      progressBar.style.width = progress * 100 + '%';
    }

    function bindFlickityEvents() {
      flickityInstance.on('scroll', updateProgressBar);
      flickityInstance.on('ready', function () {
        flickityInstance.resize();
      });
    }

    bindFlickityEvents();

    var flickityDisabled = false;

    function checkSlidesAndToggleFlickity() {
      if (flickityInstance.cells.length !== 2) {
        return;
      }

      if (window.innerWidth >= 1024 && !flickityDisabled) {
        flickityInstance.destroy();
        impactSlider.classList.add('flickity-disabled');
        flickityDisabled = true;
      } else if (window.innerWidth < 1024 && flickityDisabled) {
        flickityInstance = new Flickity(impactSlider, flickityOptions);
        impactSlider.classList.remove('flickity-disabled');
        flickityDisabled = false;
        flickityInstance.cells.forEach(function (cell) {
          cell.element.style.opacity = '';
        });
        bindFlickityEvents();
      }
    }

    checkSlidesAndToggleFlickity();
    window.addEventListener('resize', checkSlidesAndToggleFlickity);
  });
});
